<template>
  <v-dialog v-model="modelPayments" width="800px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card class="pa-0">
      <v-card-title class="py-2 px-4 bg-color-1 text-color-white font-weight-bold">
        Bandeiras Válidas
      </v-card-title>
      <v-card-item class="pa-4">
        <v-list class="pa-0 text-color-0 br-0" density="compact">
          <v-list-item v-for="(payment, index) in apo_validas" v-bind:key="index">
            <div class="d-flex align-center">
              <img :src="payment.icon" style="height: 20px;" class="me-3"><b>{{ payment.name }}</b>
            </div>
          </v-list-item>
        </v-list>
      </v-card-item>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'DialogPayments',
  data(){
    return {
      modelPayments: false
    }
  },
  props: {
    apo_validas: {
      type: Array,
      default: []
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelPayments = this.model;
    },
  },
  computed: {
    ...mapGetters('main', {
      getPaymentById: 'getPaymentById'
    }),
  }
}
</script>